import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useToasts } from '../../../cdl/Toast/useToasts';
import { updateSupplierSettings } from '../../../common/api/clients/company.api';
import { queries } from '../../../common/api/queryKeys/queries';
import { translate } from '../../../common/helpers/translate.helper';

export const useSupplierSettingsEdit = () => {
    const queryClient = useQueryClient();
    const { addErrorToast } = useToasts();

    return useMutation({
        mutationFn: updateSupplierSettings,
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({
                queryKey: queries.suppliers.detail(variables.id)._ctx.settings.queryKey,
            });
        },
        onError: () => {
            addErrorToast(translate('company.toasts.informationUpdateError'));
        },
    });
};
